var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBoostConversation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBoostConversation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-9.66389274%",
    y1: "-38.1384144%",
    x2: "100%",
    y2: "123.119536%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A78",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-9.37762319%",
    y1: "-38.2927959%",
    x2: "99.2993979%",
    y2: "122.562148%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A78",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-36.9997995%",
    y1: "21.1127241%",
    x2: "162.901281%",
    y2: "82.0755999%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A78",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Plus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger---plus-popup",
    transform: "translate(-568.000000, -438.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(418.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icBoostConversation",
    transform: "translate(150.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boost",
    transform: "translate(10.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0 C62.0560938,0 80,17.94375 80,39.9995313 C77.9971875,92.978125 2.0109375,92.9925 0,40 C0,17.9439063 17.9439063,0 40,0 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "thunder",
    transform: "translate(27.428571, 16.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.91847396,45.6059259 C9.52202729,45.8639042 10.2237817,45.6485213 10.5763074,45.0916625 L26.6164077,19.6057254 C26.8761682,19.1932275 26.8918519,18.6723698 26.6568644,18.2468616 C26.4218769,17.8200167 25.9728432,17.5549986 25.4859371,17.5549986 L14.7807742,17.5549986 L18.7621053,1.75469786 C18.9226845,1.11639098 18.5976051,0.457142857 17.9932498,0.197382345 C17.3928154,-0.0610414926 16.6866054,0.155588972 16.3354163,0.711645781 L0.295316068,26.1975828 C0.0355555556,26.6100808 0.019871902,27.1309385 0.254859371,27.5564467 C0.489846839,27.9832916 0.938880535,28.2483097 1.42578669,28.2483097 L12.1309496,28.2483097 L8.14961849,44.0486104 C7.98903926,44.6870064 8.31402952,45.3461654 8.91847396,45.6059259 L8.91847396,45.6059259 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(35.000000, 63.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,0 C77.5701172,0 100,22.5031248 100,50.1631176 C97.4964844,116.603182 2.51367188,116.62121 0,50.1637055 C0,22.5033207 22.4298828,0 50,0 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(21.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98614475e-12,22.7539714 C3.98614475e-12,28.7439976 2.10907269,36.8898887 12.1588182,41.6794339 C12.4767327,41.830701 12.678575,42.1443758 12.678575,42.4870167 L12.678575,53.6050157 L26.457011,45.4197653 C26.625213,45.3115759 26.8291097,45.2484448 27.0214506,45.2719643 L27.3694103,45.2900371 C27.9040614,45.3187555 28.4369149,45.345741 28.9792699,45.345741 C45.5002965,45.345741 58.2021818,35.6334562 58.2021818,22.7539714 C58.2021818,9.87448655 45.5021412,0 28.9811146,0 C12.460088,0 3.98614475e-12,9.87448655 3.98614475e-12,22.7539714 Z",
    id: "Mask-Copy-2",
    fill: "#FFFFFF",
    transform: "translate(29.101091, 26.802508) scale(-1, 1) translate(-29.101091, -26.802508) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5739141,25.5588715 C20.7325585,25.5588715 22.4824855,23.8884866 22.4824855,21.8279624 C22.4824855,19.7674382 20.7325585,18.0970533 18.5739141,18.0970533 C16.4152697,18.0970533 14.6653427,19.7674382 14.6653427,21.8279624 C14.6653427,23.8884866 16.4152697,25.5588715 18.5739141,25.5588715 Z M30.1789091,25.5588715 C32.3375535,25.5588715 34.0874805,23.8884866 34.0874805,21.8279624 C34.0874805,19.7674382 32.3375535,18.0970533 30.1789091,18.0970533 C28.0202647,18.0970533 26.2703377,19.7674382 26.2703377,21.8279624 C26.2703377,23.8884866 28.0202647,25.5588715 30.1789091,25.5588715 Z M41.7839041,25.5588715 C43.9425485,25.5588715 45.6924755,23.8884866 45.6924755,21.8279624 C45.6924755,19.7674382 43.9425485,18.0970533 41.7839041,18.0970533 C39.6252597,18.0970533 37.8753327,19.7674382 37.8753327,21.8279624 C37.8753327,23.8884866 39.6252597,25.5588715 41.7839041,25.5588715 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-3)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoostConversation);
export default __webpack_public_path__ + "static/media/icBoostConversation.bd273d81ca9dc0799bd8c8f55ac9f54d.svg";
export { ForwardRef as ReactComponent };